import React, { useState, useEffect, useContext } from "react";

import db from "../../../services/query";
import { HalfYearContext } from "../../../contexts/halfYearContext";

import TableMainSearch from "../../common/MainSearch";
import MainButton from "../../common/MainButton";
import MainTitle from "../../common/MainTitle";
import DataTable from "./ClassListTable";

import lbl from "../../../data/Labels.json";
import MainPrintLink from "../../common/MainPrint";

const FinanceClassList = (props) => {
  const [data, setData] = useState([]);
  const [query, setQuery] = useState("");
  const { halfYear } = useContext(HalfYearContext);
  const { fid } = props.match.params;

  useEffect(() => {
    const ac = new AbortController();

    requestData({ halfYear });

    return () => ac.abort();
  }, [halfYear]);

  const requestData = async (p = new Object()) => {
    try {
      const { halfYear } = p;

      let query = `students/fees/faculties/${fid}/classes?halfYearId=${halfYear}`;

      await db.getAll(query).then(({ data }) => {
        setData(data);
      });
    } catch ({ response }) {
      setData(response);
    }
  };

  return (
    <div className="main-content">
      <div className="main-content-header">
        <div className="right-content">
          <MainButton title={lbl.PrevPage} type={"back"} />
          <MainTitle title={data?.summary?.title} />
        </div>
        <div className="center-content">
          <TableMainSearch setQuery={setQuery} />
        </div>
        <div className="left-content">
          <MainPrintLink path={`facultiesIncomeList/${fid}/classes/${halfYear}?&title=${data?.summary?.title}`} />
        </div>
      </div>
      <div className="main-content-body">
        <DataTable data={data} {...props} query={query} />
      </div>
    </div>
  );
};

export default FinanceClassList;
